import React, { Suspense } from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';
import { LoadingSpinner } from 'src/components/common/LoadingSpinner';
import { PublicLayout } from 'src/components/layout/public/PublicLayout';
import { authRoutes, publicRoutes } from 'src/config/routes';
import { NotFound } from '../components/errors/NotFound';
import IndexRoute from './components/IndexRoute';
import { RouteConfig } from 'src/types/route-config.types';
import { useAuth } from 'src/hooks/auth/useAuth';
import AuthLayout from './auth/AuthLayout';


const renderRoute = (route: RouteConfig): React.ReactNode => {
  const Component = route.component;
  if (route.children && route.children.length > 0) {
    return (
      <Route
        key={route.path}
        path={`${route.path}/*`}
        element={
          Component ? (
              <Component />
          ) : (
            <Outlet />
          )
        }
      >
        {route.children.map((childRoute) => renderRoute(childRoute))}
      </Route>
    );
  }

  return (
    <Route
      key={route.path}
      path={route.path}
      element={
        Component ? (
          <Suspense fallback={<LoadingSpinner />}>
            <Component />
          </Suspense>
        ) : null
      }
    />
  );
};


export const AuthRoutes: React.FC = () => {

  const { user } = useAuth()

  return (
    <Routes>
      {!user &&<Route element={<AuthLayout />}>
        <Route index element={<IndexRoute routes={authRoutes} />} />
        {authRoutes.map((route) => renderRoute(route))}
        {/* <Route path='/home' element={<HomePage />} /> */}
        <Route path="*" element={<NotFound layout="auth" />} />
      </Route>}
    </Routes>
  );
};